import { render } from "./MetaFeed.vue?vue&type=template&id=00920578&scoped=true"
import script from "./MetaFeed.vue?vue&type=script&lang=js"
export * from "./MetaFeed.vue?vue&type=script&lang=js"

import "./MetaFeed.vue?vue&type=style&index=0&id=00920578&lang=scss&scoped=true"

import exportComponent from "D:\\Development\\JS\\SeptaCode\\septacode.com\\demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00920578"]])

export default __exports__